import { Play, Pause, Loader2, Volume2 } from "lucide-react";
import { useTtsPlayer } from "@/lib/useTtsPlayer";
import { SpeakingAvatar } from "@/components/SpeakingAvatar";

const BUTTON_STATES = {
  loading: (size) => ({ icon: <Loader2 size={size} className="animate-spin" />, label: "Loading…" }),
  playing: (size) => ({ icon: <Pause size={size} fill="currentColor" />, label: "Pause" }),
  error: (size) => ({ icon: <Volume2 size={size} />, label: "Try again" }),
};

/**
 * Compact ElevenLabs audio player: fetches MP3 from POST /api/tts/generate on click, plays it, and shows the speaking chip.
 * Props: text (required), label, variant "inline" | "block", testid, analyticsKind/analyticsId, bookmarkTitle/bookmarkUrl, autoPlay.
 */
export default function AudioListen({ text, label = "Listen", variant = "inline", testid, analyticsKind, analyticsId, bookmarkTitle, bookmarkUrl, autoPlay = false, speakerLabel = "Rich · narrating", speakerAvatar = "/author/avatar.jpg" }) {
  const { state, enabled, play } = useTtsPlayer({ text, analyticsKind, analyticsId, bookmarkTitle, bookmarkUrl, autoPlay });
  if (enabled === false) return null;

  const isBlock = variant === "block";
  const iconSize = isBlock ? 16 : 13;
  const { icon, label: btnLabel } = BUTTON_STATES[state]?.(iconSize) || { icon: <Play size={iconSize} fill="currentColor" />, label };

  return (
    <>
      <button
        onClick={play}
        disabled={state === "loading"}
        data-testid={testid || "audio-listen"}
        className={
          isBlock
            ? "btn-outline text-sm w-fit disabled:opacity-60"
            : "inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C] hover:text-[#B45309] transition-colors disabled:opacity-60"
        }
        aria-label={label}
      >
        {icon}
        <span>{btnLabel}</span>
      </button>
      {state === "playing" && <SpeakingAvatar speakerLabel={speakerLabel} speakerAvatar={speakerAvatar} />}
    </>
  );
}
